import { NavLink } from "react-router-dom"
import { useTaskTags } from "../../api/queries/useTaskTags"
import styles from "./styles.module.css"
import { useContext } from "react"
import userContext, { UserRole } from "../../context/userContext"

export default function Homepage() {
  const { hasRole } = useContext(userContext)
  const { data: taskTags = [] } = useTaskTags()
  const ehsTag = taskTags.find((tag) => tag.key === "ehs")
  const nekvalitaTag = taskTags.find((tag) => tag.key === "nekvalita")

  return (
    <>
      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={"/tasks/reports"}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Hlášení
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={"/tasks/preventions"}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Pravidelná údržba
            </div>
          </div>
        </NavLink>
      </div>

      {(hasRole(UserRole.Admin) || hasRole(UserRole.Vedouci) || hasRole(UserRole.Technik) || hasRole(UserRole.TzvVedouci) || hasRole(UserRole.TzvTechnik)) && (
        <div className={"col-12 md:col-3 text-center"}>
          <NavLink to={"/tasks/management"}
            className={`block p-card p-component ${styles.bgBlue}`}>
            <div className={"p-card-body"}>
              <div className={"p-card-content"}>
                Management
              </div>
            </div>
          </NavLink>
        </div>
      )}

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={"/tasks/machines"} className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Stroje
            </div>
          </div>
        </NavLink>
      </div>

      {(hasRole(UserRole.Admin) || hasRole(UserRole.Vedouci) || hasRole(UserRole.TzvVedouci)) && (
        <div className={"col-12 md:col-3 text-center"}>
          <NavLink to={"/enum/users"}
            className={`block p-card p-component ${styles.bgBlue}`}>
            <div className={"p-card-body"}>
              <div className={"p-card-content"}>
                Pracovníci
              </div>
            </div>
          </NavLink>
        </div>
      )}

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={"/warehouses"}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Sklad
            </div>
          </div>
        </NavLink>
      </div>

      {(hasRole(UserRole.Admin) || hasRole(UserRole.Vedouci) || hasRole(UserRole.Technik) || hasRole(UserRole.TzvVedouci) || hasRole(UserRole.TzvTechnik)) && (
        <div className={"col-12 md:col-3 text-center"}>
          <NavLink to={"/enum/warehouse/suppliers"}
            className={`block p-card p-component ${styles.bgBlue}`}>
            <div className={"p-card-body"}>
              <div className={"p-card-content"}>
                Dodavatelé
              </div>
            </div>
          </NavLink>
        </div>
      )}

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={`/tasks/reports?tag=${ehsTag ? ehsTag.uuid : ""}`}
          className={`block p-card p-component ${styles.bgYellow}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              EHS
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={`/tasks/reports?tag=${nekvalitaTag ? nekvalitaTag.uuid : ""}`}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Nekvalita
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={"/gwps"}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              GWP
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={`/gfps`}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              GFP
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={`/vzvs`}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              VZV
            </div>
          </div>
        </NavLink>
      </div>

      <div className={"col-12 md:col-3 text-center"}>
        <NavLink to={`/tasks/calendar`}
          className={`block p-card p-component ${styles.bgBlue}`}>
          <div className={"p-card-body"}>
            <div className={"p-card-content"}>
              Kalendář
            </div>
          </div>
        </NavLink>
      </div>
    </>
  )
}
